<template>
    <div class="breadcrumb-section default" v-if="baseInfo != null">
        <ul class="breadcrumb-list">
            <li>
                <router-link class="name-store" target="_blank" tag="a" to="/" :title="baseInfo.ShopName">
                    <span >{{baseInfo.ShopName}}</span>
                </router-link>
            </li>
            <li><span>{{ breadcrumbName }}</span></li>
        </ul>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    export default {
        data() {
            return {
                breadcrumbName: '',
            }
        },
        methods: {
            breadcrumbCreator() {
                if (!IsNullOrEmptyString(this.$route.query.GroupName)) {
                    this.breadcrumbName = 'جستجو در گروه ' + this.$route.query.GroupName;
                } else {
                    if (!IsNullOrEmptyString(this.$route.query.SubGroupName)) {
                        this.breadcrumbName = 'جستجو در زیر گروه ' + this.$route.query.SubGroupName;
                    } else {
                        if (!IsNullOrEmptyString(this.$route.query.TagName)) {
                            this.breadcrumbName = 'جستجو در برچسب ' + this.$route.query.TagName;
                        } else {
                            if (!IsNullOrEmptyString(this.$route.query.SearchValue)) {
                                this.breadcrumbName = 'جستجوی عبارت  ' + '"' + this.$route.query.SearchValue + '"';
                            } else {
                                if (!IsNullOrEmptyString(this.$route.query.BrandName)) {
                                    this.breadcrumbName = 'جستجوی برند  ' + '"' + this.$route.query.BrandName + '"';
                                }
                            }
                        }
                    }
                }
                this.breadcrumbName = this.breadcrumbName.replace(/-/g, ' ');
                createPageTitle(this.breadcrumbName);
            },
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        created() {
            filterEventBus.$on('breadcrumbCreator', this.breadcrumbCreator )
        },
        beforeDestroy() {
            filterEventBus.$off('breadcrumbCreator');
        }
    }
</script>

<style scoped>

    .name-store {
        margin-bottom: 20px;
        display: block;
    }
</style>